import { defineStore } from 'pinia';
import useApiStore from '@/stores/modules/api';

const useBranchApiStore = defineStore('branchApi', {
    actions: {
        // 점포 정보 조회
        getStoreInfo(params) {
            const url = '/emartapi/storeInfo/getStoreDetailInfo.do';
            const requestUrl = process.env.NODE_ENV === 'development' ? url : process.env.VUE_APP_EMART_API + url;
            return useApiStore().requestApi({ url: requestUrl, method: 'post', data: params });
        },
        // 스타필드 정보조회
        getStarFieldInfo(url) {
            const requestUrl = process.env.VUE_APP_API_URL + '/promotion/api/v1/sfmarket' + url;
            return useApiStore().requestApi({ url: requestUrl, method: 'get' });
        },
    },
});

export default useBranchApiStore;
